module.exports = __webpack_public_path__ + "img/tec.b9b02dea.png";